declare global {
  interface Window {
    __ENV__?: Record<string, string>;
  }
}

const runtime = window.__ENV__ ?? {};
const params = new URLSearchParams(window.location.search);

export const env = {
  apiBaseUrl: runtime.API_BASE_URL || import.meta.env.VITE_API_BASE_URL || "/api",
  /** Dry-run the launch screen with a tuning panel: nothing is submitted, it can replay. */
  tweak: params.has("tweak"),
} as const;
